import React from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export default function GamingVenueMappingForm({
  venueCheck,
  venueMappings,
  onChange,
}) {
  const unmatched = venueCheck?.unmatched_file_venues || []
  const venues = venueCheck?.configured_venues || []

  if (!unmatched.length) return null

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950 space-y-3">
      <div className="flex gap-2 items-start">
        <ExclamationTriangleIcon className="w-5 h-5 shrink-0 text-amber-600" />
        <div>
          <p className="font-medium">Map extract site names to venues</p>
          <p className="mt-1 text-xs text-amber-900">
            Site name(s) in this file do not match any configured <strong>Gaming extract name</strong>.
            Choose which venue each label should import as — rows will be stored under that venue&apos;s extract name.
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {unmatched.map((fileName) => (
          <label key={fileName} className="block">
            <span className="text-xs font-medium text-gray-700">
              <span className="font-mono">{fileName}</span>
              {' → '}
            </span>
            <select
              className="mt-1 block w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
              value={venueMappings[fileName] || ''}
              onChange={(e) => onChange(fileName, e.target.value)}
            >
              <option value="">Select venue…</option>
              {venues.map((v) => (
                <option key={v.venue_id} value={v.venue_id}>
                  {v.name}
                  {v.gaming_extract_venue_name ? ` (extract: ${v.gaming_extract_venue_name})` : ''}
                </option>
              ))}
            </select>
          </label>
        ))}
      </div>

      {venueCheck?.file_venue_names?.some((n) => !unmatched.includes(n)) && (
        <p className="text-xs text-gray-600">
          Other site names in the file already match configured venues and do not need mapping.
        </p>
      )}
    </div>
  )
}
